import React from 'react';
import { Shield, AlertTriangle, CheckCircle } from 'lucide-react';
import './ChatComponents.css';

/**
 * Circular gauge showing framework coverage score
 */
function CoverageGauge({ data }) {
  const { score = 0, label, total = 0, covered = 0, gaps = 0 } = data;

  // Calculate stroke dasharray for circular progress
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const progress = (score / 100) * circumference;

  // Determine color based on score
  const getColor = (score) => {
    if (score >= 80) return 'var(--color-success)';
    if (score >= 50) return 'var(--color-warning)';
    return 'var(--color-error)';
  };

  const color = getColor(score);

  return (
    <div className="cc-gauge-container">
      <div className="cc-gauge">
        <svg viewBox="0 0 100 100" className="cc-gauge-svg">
          {/* Background circle */}
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke="var(--color-border)"
            strokeWidth="8"
          />
          {/* Progress circle */}
          <circle
            cx="50"
            cy="50"
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={circumference - progress}
            transform="rotate(-90 50 50)"
            style={{ transition: 'stroke-dashoffset 0.5s ease-out' }}
          />
        </svg>
        <div className="cc-gauge-center">
          <span className="cc-gauge-score" style={{ color }}>{score}%</span>
          <span className="cc-gauge-label">{label}</span>
        </div>
      </div>

      <div className="cc-gauge-stats">
        <div className="cc-gauge-stat">
          <CheckCircle size={14} color="var(--color-success)" />
          <span>{covered} addressed</span>
        </div>
        <div className="cc-gauge-stat">
          <AlertTriangle size={14} color="var(--color-warning)" />
          <span>{gaps} gaps</span>
        </div>
        <div className="cc-gauge-stat">
          <Shield size={14} color="var(--color-text-muted)" />
          <span>{total} total controls</span>
        </div>
      </div>
    </div>
  );
}

export default CoverageGauge;
